import { toast } from '@/helpers/toast/toast.helper'
import { AxiosResponse } from 'axios'
import { put } from 'redux-saga/effects'
import { createNewGroupAction } from '../../handles'
import { buildNewChat } from './helpers'
import { zApiMultiService } from '@/services/api'
import { GroupModel } from '@/models/group.model'
import { createGroup } from '../_http/groups'

export function* createNewGroupSaga(action: ReturnType<typeof createNewGroupAction.request>) {
  const { campaign, groupName, groupImage, phones, department, callBack } = action.payload
  try {
    const uniquePhones = [...new Set(phones)]
    const phonesList = uniquePhones.join(',')

    const formData = new FormData()
    formData.append('groupName', groupName)
    formData.append('phones', phonesList)
    groupImage && formData.append('photoFile', groupImage)

    const url = `/instances/campanhaId/${campaign.id}/token/${campaign.token}/create-group`
    const createdGroupResponse: AxiosResponse = yield zApiMultiService.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    // eslint-disable-next-line max-len
    const urlGetGroup = `/instances/campanhaId/${campaign.id}/token/${campaign.token}/group-metadata/${createdGroupResponse.data.phone}`
    const groupMetaDataResponse: AxiosResponse<GroupModel> = yield zApiMultiService.get(urlGetGroup)

    const groupChat = yield buildNewChat({
      campaign,
      department,
      group: groupMetaDataResponse.data,
      ownerId: campaign.ownerId,
      groupImageUrl: createdGroupResponse.data.imgUrl
    })

    yield createGroup(groupChat)

    yield put(createNewGroupAction.success())

    callBack?.()
  } catch (error) {
    let message = null
    if (error.message === 'chatAlreadyExists' || error.response?.data?.error === 'chatAlreadyExists') {
      message = 'O grupo já existe'
    } else {
      message = 'Erro ao criar grupo'
    }
    toast({ type: 'error', message })
    console.log({ createNewGroupSaga: error })
    yield put(createNewGroupAction.failure(error))
  }
}
